import federation from '/srv/parcel_monitor_community/node_modules/@module-federation/webpack-bundler-runtime/dist/index.cjs.js';
import plugin_0 from '/srv/parcel_monitor_community/node_modules/@module-federation/nextjs-mf/dist/src/plugins/container/runtimePlugin.js';

var prevFederation = __webpack_require__.federation;
__webpack_require__.federation = {}
for(var key in federation){
	__webpack_require__.federation[key] = federation[key];
}
for(var key in prevFederation){
	__webpack_require__.federation[key] = prevFederation[key];
}
if(!__webpack_require__.federation.instance){
	const pluginsToAdd = [
		plugin_0 ? plugin_0() : false,
	].filter(Boolean);
	__webpack_require__.federation.initOptions.plugins = __webpack_require__.federation.initOptions.plugins ? 
	__webpack_require__.federation.initOptions.plugins.concat(pluginsToAdd) : pluginsToAdd;
	__webpack_require__.federation.instance = __webpack_require__.federation.runtime.init(__webpack_require__.federation.initOptions);
	if(__webpack_require__.federation.attachShareScopeMap){
		__webpack_require__.federation.attachShareScopeMap(__webpack_require__)
	}
	if(__webpack_require__.federation.installInitialConsumes){
		__webpack_require__.federation.installInitialConsumes()
	}
}